import Carousel from 'react-bootstrap/Carousel';
import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import classes from './MediaGallery.module.css';

function MyCarousel({ folderPath, onClick, defaultActiveIndex }) {
    const [mediaData, setMediaData] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const loadMedia = async () => {
            const response = await fetch(`${folderPath}/media.json`);
            const files = await response.json();
            const media = files.map(file => {
                const ext = file.split('.').pop().toLowerCase();
                const isVideo = ['mp4', 'webm', 'ogg'].includes(ext);
                return {
                    url: `${folderPath}/${file}`,
                    video: isVideo,
                    loaded: false
                };
            });
            setMediaData(media);

            files.forEach((file, index) => {
                const ext = file.split('.').pop().toLowerCase();
                const isVideo = ['mp4', 'webm', 'ogg'].includes(ext);
                
                if (isVideo) {
                    setMediaData(prev => {
                        const updated = [...prev];
                        updated[index].loaded = true;
                        return updated;
                    });
                } else {
                    const img = new Image();
                    img.onload = () => {
                        setMediaData(prev => {
                            const updated = [...prev];
                            updated[index].loaded = true;
                            return updated;
                        });
                    };
                    img.src = `${folderPath}/${file}`;
                }
            });
        };

        loadMedia();
        setActiveIndex(defaultActiveIndex || 0);
    }, [folderPath]);

    return (
        <Carousel interval={3000} pause='hover' activeIndex={activeIndex} onSelect={(index) => setActiveIndex(index)}>
            {mediaData.map((item, index) => (
                <Carousel.Item key={index} onClick={() => onClick(index)}>
                    {item.loaded ? (
                        item.video ? (
                            <video autoPlay loop muted className={classes.carouselImage}>
                                <source src={item.url} type={`video/${item.url.split('.').pop()}`} />
                            </video>
                        ) : (
                            <img className={classes.carouselImage} src={item.url} />
                        )
                    ) : (
                        <div className={classes.carouselImage} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f0f0' }}>
                            Loading...
                        </div>
                    )}
                </Carousel.Item>
            ))}
        </Carousel>
    );
}

function VerticallyCenteredModal(props) {
    return (
        <Modal show={props.show} onHide={props.onHide} size="xl" dialogClassName={classes.modalBorder} centered>
            <Modal.Body className={classes.border}>
                <MyCarousel folderPath={props.folderPath} defaultActiveIndex={props.defaultActiveIndex} />
            </Modal.Body>
        </Modal>
    );
}

function MediaGallery(props) {
    const [modalShow, setModalActive] = useState(false);
    const [modalIndex, setModalIndex] = useState(0);

    function openModal(index) {
        setModalIndex(index);
        setModalActive(true);
    }

    function closeModal() {
        setModalActive(false);
    }

    return (
        <div>
            <MyCarousel folderPath={props.folderPath} onClick={openModal} />
            <VerticallyCenteredModal show={modalShow} onHide={closeModal} folderPath={props.folderPath} defaultActiveIndex={modalIndex} />
        </div>
    );
}

export default MediaGallery;